const initialState = {
    certificatelist: [],
};

const certificateReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_CERTIFICATE_MEMBER_ACTION':
            return {
                ...state, certificatelist: action.payload
            }
        default:
            return state
    }
}

export default certificateReducer;